import { useAPIQuery } from "@dev2_techwalnut/tw-api-query-hook";
import moment from "moment";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";

const FilterModal = ({ setDate, setDepartment }) => {
    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });
    const { register, handleSubmit, control } = useForm({
        defaultValues: {
            date: moment().format("YYYY-MM-DD"),
        },
    });
    const onSubmit = (data) => {
        console.log(data);
        setDate(data?.date);
        setDepartment(data?.department?.value ?? "");
    };

    return (
        <div
            className="modal fade m-0 p-0"
            tabIndex={-1}
            id="machine-detials-filter-modal"
            aria-modal
        >
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Filter</h5>
                        <button
                            type="button"
                            className="close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        >
                            <em className="icon ni ni-cross" />
                        </button>
                    </div>

                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row g-3 w-100">
                                <div className="col-12">
                                    <label className="form-label mb-0">
                                        Date:
                                    </label>
                                    <input
                                        type="date"
                                        className="form-control"
                                        {...register("date")}
                                        onWheel={(e) => e.target.blur()}
                                    />
                                </div>
                                <div className="col-12">
                                    <label className="form-label">
                                        Department
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={
                                                    data?.department?.map(
                                                        (dept) => ({
                                                            value: dept?.department_name,
                                                            label: dept?.department_name,
                                                        })
                                                    ) ?? []
                                                }
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-department"
                                            />
                                        )}
                                        name={`department`}
                                        control={control}
                                    />
                                </div>
                            </div>
                        </div>

                        <div className="modal-footer bg-light">
                            <button
                                type="submit"
                                className="btn btn-primary"
                                data-bs-dismiss="modal"
                            >
                                Submit
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default FilterModal;
